"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
var easing1 = "cubic-bezier(0.215, 0.61, 0.355, 1)";
var easing2 = "cubic-bezier(0.755, 0.05, 0.855, 0.06)";
var transformOrigin = "center bottom";
var frame1 = {
  transform: "translate3d(0, 0, 0)",
  easing: easing1,
  transformOrigin: transformOrigin
};
var frame2 = {
  transform: "translate3d(0, -30px, 0) scaleY(1.1)",
  easing: easing2,
  transformOrigin: transformOrigin
};
exports.default = {
  keyframes: [__assign(__assign({}, frame1), {
    offset: 0
  }), __assign(__assign({}, frame1), {
    offset: 0.2
  }), __assign(__assign({}, frame2), {
    offset: 0.4
  }), __assign(__assign({}, frame2), {
    offset: 0.43
  }), __assign(__assign({}, frame1), {
    offset: 0.53
  }), {
    transform: "translate3d(0, -15px, 0) scaleY(1.05)",
    easing: easing2,
    transformOrigin: transformOrigin,
    offset: 0.7
  }, {
    transform: "translate3d(0, 0, 0) scaleY(0.95)",
    easing: easing1,
    transformOrigin: transformOrigin,
    offset: 0.8
  }, {
    transform: "translate3d(0, -4px, 0) scaleY(1.02)",
    transformOrigin: transformOrigin,
    offset: 0.9
  }, __assign(__assign({}, frame1), {
    offset: 1
  })],
  timing: {
    duration: 1000,
    fill: "both"
  }
};